import { makeUseVisualState } from '../../motion/utils/use-visual-state.js';
import { scrapeMotionValuesFromProps } from './utils/scrape-motion-values.js';
import { createHtmlRenderState } from './utils/create-render-state.js';
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    createRenderState: createHtmlRenderState
  })
};
export { htmlMotionConfig };